import { render, staticRenderFns } from "./CopyTemplateDialog.vue?vue&type=template&id=79ca5eba"
import script from "./CopyTemplateDialog.vue?vue&type=script&lang=js"
export * from "./CopyTemplateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports